var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26511 20.3063L9.40211 17.2L12.5391 20.3063L9.40211 23.4125L6.26511 20.3063ZM20.1828 12.7812L25.5731 18.1188L28.7101 15.0125L23.3198 9.67498L20.1828 6.56873L17.0458 9.67498L11.6554 14.9687L14.7924 18.075L20.1828 12.7812ZM27.8264 20.3063L30.9634 17.2L34.1004 20.3063L30.9634 23.4125L27.8264 20.3063ZM20.1828 27.8313L14.7924 22.5375L11.6554 25.6438L17.0458 30.9375L20.1828 34.0438L23.3198 30.9375L28.7101 25.6L25.5731 22.5375L20.1828 27.8313Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0458 20.3063L20.1828 17.2L23.3198 20.3063L20.1828 23.4125L17.0458 20.3063Z",
    fill: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 29,
    height: 29,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.fb56ff00103311a57c6e5cd63d028c53.svg";
export { ForwardRef as ReactComponent };